export const SITE_URL = "https://intelligence_API.cerebro360.ai"; //"https://devbi_api.cerebro.mobi"; //"https://uatbiapi.cerebro360.ai"; // "https://localhost:5001"; //"https://intelligence_API.cerebro360.ai";//"https://devbi_api.cerebro.mobi"; //

export const SITE_API_URL = SITE_URL + "/api";

export const SITE_CONNECTION_TIMEOUT_SHORT = 30000; //0.5 minute
export const SITE_CONNECTION_TIMEOUT_AVERAGE = 60000; //1 minute
export const SITE_CONNECTION_TIMEOUT_LONG = 120000; //2 minutes
export const SITE_CONNECTION_TIMEOUT_VERY_LONG = 300000; //5 minutes
export const SITE_CONNECTION_TIMEOUT_EXTREMELY_LONG = 600000; //10 minutes

export const ERROR_MESSAGES = {
  noConnection: { en: "You are not connected to the Internet!" },
  networkError: {
    en: "A network error was detected! Maybe the server is not available.",
  },
  timedOut: { en: "The server seems busy! The connection has timed out." },
  canceled: { en: "The operation was canceled!" },
  unAuthenticated: { en: "You are not logged to the system!" },
  unAuthorized: {
    en: "You are not authorized to access the specified resource.",
  },
  unHandled: { en: "An unknown error occured!" },
};

export const ROUTING_PATHS = {
  home: "/",
  features: "/features",
  subscription: "/subscription",
  terms: "/termsandconditions",
  privacy: "/privacy-policy",
  support: "/support",
  login: "/login",
  onboarding: "/onboarding",
  resetPassword: "/resetpassword/:id",
  unAuthorized: "/unauthorized",
  error: "/error",

  expressions: "/expressions",
  dataSources: "/datasources",
  alerts: "/alerts",
  notifications: "/notifications",
  reports: "/reports",
  reportingDesign: "/reportingdesign/:id",
  reportingView: "/reportingview/:id",
  users: "/users",
  securityGroups: "/securitygroups",
  reportsMenu: "/sidebardesigner",
  migrations: "/migrations",
  dataConsumption: "/dataconsumption",
  dataSets: "/datasets",
  datasetView: "/datasetview/:id",
  createDataset: "/createdataset",
  importDataset: "/importdataset",
  dataCorrection: "/datacorrection",
  accountManagement: "/accountmanagement",
  schedule: "/schedule",
  scheduleView: "/scheduleview/:id",
  createSchedule: "/createschedule",
  importSchedule: "/importschedule",
  connection:"/connection",
  connectionView: "/connectionview/:id",
  createconnection: "/createconnection",
};

export const MESSAGES = {
  youAreOnline: "You are back online!",
  youAreOffline: "You are offline!",
};

export const disAllowedCharactersInTitle = [
  "(",
  ")",
  "[",
  "]",
  "{",
  "}",
  "@",
  ",",
  ".",
  ";",
  ":",
  "!",
  "?",
  "<",
  ">",
  "#",
  "&",
  "*",
  "~",
  "+",
];

export const APP_HEADER_HEIGHT = 42;

export const NOTIFICATIONS_PAGE_SIZE = 50;

export const NOTIFICATIONS_UPDATE_COUNT_IN_MILLISECONDS = 300000; //5 minutes

export const APP_TITLE = "Intelligence";

export const SIGNALR_CONNECTIONID_HEADER_NAME = "vas-signalr-connectionid";

export const BLOCK_DIRTY_MESSAGE =
  "The page contains unsaved data. Are you sure that you want to proceed without saving?";

export const BLOCK_DIRTY_MESSAGE_NAVIGATE =
  "The page you are leaving contains unsaved data. Are you sure that you want to leave that page without saving?";

export const BILLING_PAYMENT_MESSAGE =
  "Please finish your payment subscription.";

export const LoginUrl = "auth/login"; //"auth/syslogin";
export const FederationId = ""; //"AB0FB049-59E5-4FCC-B3D7-A998F5381780"; 